// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGSplitSeries1IconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer",
  display: "block",
};

export default class SVGSplitSeries1Icon extends PureComponent<
  ISVGSplitSeries1IconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill, className } = props;
    return (
      <svg
        {...props}
        className={"with-stroke"}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
        preserveAspectRatio="xMidYMid meet"
      >
        <g id="Layer_3">
          <line
            // fill="none"
            // stroke="#FFFFFF"
            // strokeWidth="0.8"
            // strokeMiterlimit="10"
            x1="9.667"
            y1="2.167"
            x2="9.667"
            y2="33.084"
          />
          <line
            // fill="none"
            // stroke="#FFFFFF"
            // strokeWidth="0.8"
            // strokeMiterlimit="10"
            x1="17.648"
            y1="2.583"
            x2="17.648"
            y2="33.167"
          />
          <line
            // fill="none"
            // stroke="#FFFFFF"
            // strokeWidth="0.8"
            // strokeMiterlimit="10"
            x1="25.917"
            y1="2.583"
            x2="25.917"
            y2="33.167"
          />
          <line
            // fill="none"
            // stroke="#FFFFFF"
            // strokeWidth="0.8"
            // strokeMiterlimit="10"
            x1="1.077"
            y1="12.583"
            x2="34.221"
            y2="12.583"
          />
          <line
            // fill="none"
            // stroke="#FFFFFF"
            // strokeWidth="0.8"
            // strokeMiterlimit="10"
            x1="1.077"
            y1="22.917"
            x2="34.221"
            y2="22.917"
          />
          <path
            fill="none"
            // stroke="#FFFFFF"
            strokeWidth="1.5"
            // strokeMiterlimit="10"
            d="M34.221,31.167c0,1.104-0.896,2-2,2H3.076
		c-1.104,0-2-0.896-2-2V4.25c0-1.104,0.896-2,2-2h29.145c1.104,0,2,0.896,2,2V31.167z"
          />
        </g>
      </svg>
    );
  }
}
